<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="0" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="0" :currentTab2="1" />
            <div class="tab-content">
              <div>
                <div class="task-list krs006">
                  <div class="dashboard_box_grp clear">
                    <div class="fl" id="folder" style="width: 330px;">
                      <div class="tb-header clear">
                        <div class="tb_num fl">
                            <div class="num">{{$i18nUtil.trans("message.RoleUserList.001","권한 목록")}}</div>
                        </div>
                      </div>

                      <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="roleList"
                        hide-default-footer
                        class="tb-contents"
                      >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>
                            <span 
                              class="ell-singleline d-block cursor-pointer" 
                              @click="selectRoleUser(item.roleId, item.roleName)" 
                              style="text-overflow: ellipsis;overflow: hidden;width: 90px;"
                            >{{ item.roleId }}
                            </span>
                          </td>
                          <td>
                            <div>
                              <span>{{ item.roleName }}</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        <div class="nodata-txt-noicon">
                          <v-alert :value="true">
                            {{$i18nUtil.trans("message.RoleList.001","권한 리스트가 없습니다.")}}
                          </v-alert>
                        </div>
                      </template>
                      </v-data-table>

                      <div v-show="pageCount > 0" class="pagination">
                        <v-pagination
                            v-model="page"
                            circle
                            :length="pageCount"
                            :total-visible="7"
                            @input="getRoleList"
                        ></v-pagination>
                      </div>
                    </div>
                    <RoleUserViewList
                      :selectedRoleId="selectRoleId"
                      :selectedRoleName="selectRoleName"
                    ></RoleUserViewList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import AuditTab from "./AuditTab";
import AuditSubTab from "./AuditSubTab";
import RoleUserViewList from "./RoleUserViewList";

export default {
    name: "simple",
    display: "Simple",
    components: {
        AuditTab,
        AuditSubTab,
        RoleUserViewList,
    },
    data() {
      return {
        dBHeight: {
          "min-height": window.innerHeight - 151 + "px",
        },
        page: 1,
        pageCount: 0,
        totalCount : 0,
        itemsPerPage: 10,
        selected: [],
        roleList: [],
        searchUser: "",
        selectRoleId: "",
        selectRoleName: "",
        headers: [
            { text: this.$i18nUtil.trans("message.RoleManage.001","권한아이디"), value: "roleId", sortable: false },
            { text: this.$i18nUtil.trans("message.RoleManage.002","권한명"), value: "roleName", sortable: false },
        ],
        toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
            position: "bottom-left",
            duration: 3000,
          },
        },
      };
    },
    created() {
      this.getRoleList();
    },
    methods: {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
      ...mapActions("modals", ["showModal", "showToast"]),
      getRoleList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        searchUser: obj.searchUser,
      };
      reqData.url = "/api/org/role/getRoleList";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.roleList = res.result.roleList;
            obj.totalCount = res.result.roleCount;
            obj.pageCount = res.result.rolePageCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
      },
      selectRoleUser(id, name) {
        this.selectRoleId = id;
        this.selectRoleName = name;
      }
    }
}
</script> 

<style scoped>
.task-list .card_grp.active:after, :before{
    box-sizing: inherit; 
}
.tab_ty2 > .tab-menu {
    background-color: transparent;
}
.krs006 >>> ::after {
  background: none;
  visibility: hidden;
}
.krs006 >>> ::before {
  background: none;
  visibility: hidden;
}
.krs006 >>> th:nth-child(1) {
  width: 100px;
  text-align: left;
}
.krs006 >>> th:nth-child(2) {
  width: 179px;
  text-align: left;
}
.krs006 >>> td:nth-child(1) {
  width: 100px;
  text-align: left;
}
.krs006 >>> td:nth-child(2) {
  width: 179px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/RoleUserList.vue